// src/components/Banner.jsx
import React from 'react';

const Banner = () => {
  return (
    <div style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '15px',
      textAlign: 'center',
      fontSize: '18px',
      fontWeight: 'bold',
      cursor: 'pointer'
    }}
    onClick={() => window.location.assign('/')}
    >
      🚀 5분 완성 뮤지션 포트폴리오, 지금 무료로 시작하기
    </div>
  );
};

export default Banner;